// Convert Unix timestamp (milliseconds) to human-readable date
export const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';

    const numTimestamp = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;

    if (isNaN(numTimestamp)) return 'N/A';

    const date = new Date(numTimestamp);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};

